import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react';

interface Props {
  sx?: any;
  centered?: boolean;
}

const WsFormInfoContainer = (props: PropsWithChildren<Props>) => {
  const theme = useTheme();

  return (
    <Typography
      mb={1}
      sx={{
        color: theme.palette.primary.dark,
        ...(props.centered && { textAlign: 'center' }),
        ...props.sx,
      }}
      variant="subtitle2"
    >
      {props.children}
    </Typography>
  );
};

export default WsFormInfoContainer;
